"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setParameterValue = exports.objectSlice = exports.findObjects = exports.getAllObjects = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const utils_1 = __importDefault(require("../utils"));
const request_1 = require("./request");
exports.getAllObjects = (0, toolkit_1.createAsyncThunk)('objects/get-all', (_, thunk) => __awaiter(void 0, void 0, void 0, function* () { return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({ method: 'get', url: '/object/all' })); }));
exports.findObjects = (0, toolkit_1.createAsyncThunk)('objects/find-where', (data, thunk) => __awaiter(void 0, void 0, void 0, function* () { return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({ method: 'post', url: '/object/find-where', data })); }));
const initialState = {
    all: [],
    objectsForDevice: [],
    values: {},
    error: undefined
};
exports.objectSlice = (0, toolkit_1.createSlice)({
    name: 'objects',
    initialState,
    reducers: {
        setParameterValue: {
            reducer: (state, action) => {
                state.values = Object.assign(Object.assign({}, state.values), action.payload);
            },
            prepare: (nodeId, index, subIndex, valueObject) => ({
                payload: { [`${nodeId}/${index}/${subIndex}`]: valueObject }
            })
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.getAllObjects.fulfilled, (state, action) => {
            state.all = action.payload.body;
        })
            .addCase(exports.findObjects.fulfilled, (state, action) => {
            state.objectsForDevice = action.payload.body;
        });
    }
});
exports.setParameterValue = exports.objectSlice.actions.setParameterValue;
exports.default = exports.objectSlice.reducer;
